/* eslint array-callback-return: 0 */

import get from 'lodash/get'

export const getTags = (coreMediaTags, parentKey = '') => {
  if (!Array.isArray(coreMediaTags)) {
    return []
  }
  const keys = Object.keys(getNestedTags(coreMediaTags, parentKey) || {})

  return keys.reduce((acc, tag) => {
    if (tag !== 'name' && tag !== 'text') {
      acc.push(tag)
    }
    return acc
  }, [])
}

const getMatchResult = (str, pattern) => {
  const [matchedString, ...groups] = str.match(pattern) || []
  return { positiveMatch: !!matchedString, groups }
}

export const getMatchingTags = (coreMediaTags, fullKeyPattern) => {
  if (!Array.isArray(coreMediaTags) || !fullKeyPattern) {
    return []
  }

  const [parentKey, ...childrenKeys] = Array.isArray(fullKeyPattern) ? fullKeyPattern : fullKeyPattern.split('.')
  if (!parentKey) return []

  return coreMediaTags.reduce((acc, tag) => {
    const { positiveMatch, groups } = getMatchResult(tag.text, parentKey.replace('*', '(.*)'))
    if (positiveMatch) {
      const { children, text, name } = tag

      if (children && children.length > 0) {
        const nestedMatchingResults = getMatchingTags(tag.children, childrenKeys)
        return nestedMatchingResults.map(({ text: childText, name: childName, groups: childGroups }) => ({
          text: `${tag.text}.${childText}`,
          name: `${tag.name}.${childName}`,
          groups: [...groups, ...childGroups]
        }))
      } else if (childrenKeys.length === 0) {
        acc.push({
          text,
          name,
          groups
        })
      }
    }

    return acc
  }, [])
}

export const hasRootTag = (coreMediaTags, parentKey = '') => {
  if (!Array.isArray(coreMediaTags)) {
    return false
  }
  return coreMediaTags.find((tag) => tag.text === parentKey) !== undefined
}

const getNestedTags = (coreMediaTags, fullKey = '') => {
  if (!Array.isArray(coreMediaTags)) {
    return false
  }
  const allKeys = fullKey.split('.')
  const childrenPath = allKeys.slice(1, allKeys.length).join('.')
  const rootTag = coreMediaTags.reduce((acc, tag) => {
    return tag.text === allKeys[0]
      ? {
          name: tag.name,
          text: tag.text,
          ...childrenToObject(tag.children)
        }
      : acc
  }, {})

  return !childrenPath ? rootTag : get(rootTag, childrenPath)
}

const childrenToObject = (children) => {
  if (!children) {
    return {}
  }
  const childrenObject = {}

  children.map((child) => {
    childrenObject[child.text] = {
      name: child.name,
      text: child.text,
      ...childrenToObject(child.children)
    }
  })

  return childrenObject
}

export const hasTag = (coreMediaTags, fullKey = '') => {
  const allKeys = fullKey.split('.')
  const parentKey = allKeys[0]
  const childrenKey = allKeys.slice(1, allKeys.length)

  if (childrenKey.length <= 0) {
    return hasRootTag(coreMediaTags, parentKey)
  }

  return !!getNestedTags(coreMediaTags, fullKey)
}

export const getTagValue = (coreMediaTags, fullKey = '', substitute = '') => {
  return getTags(coreMediaTags, fullKey)[0] || substitute
}
